import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import React, {useCallback} from 'react';
import {Popup} from 'semantic-ui-react';

import {type PanelType} from '../../../util/panelTypes';
import {usePanelContext} from '../PanelContextProvider';
import {PanelPopupMode} from '../types';

export const PanelViewVegaSpec = ({panelType}: {panelType: PanelType}) => {
  const {setPanelPopupMode, isReadOnly} = usePanelContext();

  const onClick = useCallback(() => {
    setPanelPopupMode(PanelPopupMode.VIEW_SPEC);
  }, [setPanelPopupMode]);

  // Only show this action for published reports on vega2 panels
  if (!isReadOnly || panelType !== 'Vega2') {
    return null;
  }

  return (
    <Popup
      content="View panel spec"
      size="mini"
      position="top center"
      trigger={
        <LegacyWBIcon
          name="show"
          aria-label="View panel spec"
          className="panel-action"
          onClick={onClick}
        />
      }
    />
  );
};
